
    <!-- Sidebar -->
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" [ngClass]="{'toggled' : expended==false}" id="accordionSidebar">

      <!-- Sidebar - Brand -->
      <a class="sidebar-brand d-flex align-items-center justify-content-center" href="javascript:void(0);">
        <div class="sidebar-brand-icon rotate-n-15">
          <img src="./assets/img/logo-70.png">
        </div>
        <div class="sidebar-brand-text mx-3"><img src="./assets/img/logo.png" class="sidebar-logo"></div> 
    </a>
    
      <!-- Divider -->
      <hr class="sidebar-divider my-0">
    
      <!-- Nav Item - Dashboard -->
      <li class="nav-item active" style="visibility: hidden;">
        <a class="nav-link" [routerLink]="['/home']">
          <i class="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span></a>
      </li>
    
      <!-- Divider -->
      <hr class="sidebar-divider"  >
    
      <!-- Heading -->
      <div class="sidebar-heading">
        STORE
      </div>
    
      <!-- Nav Item - Pages Collapse Menu -->
     <!--  <li class="nav-item">
        <a class="nav-link collapsed" href="orders.html" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
          <i class="fas fa-fw fa-file-alt"></i>
          <span>Orders</span>
        </a>
         <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
            <h6 class="collapse-header">Custom Components:</h6>
            <a class="collapse-item" href="buttons.html">Buttons</a>
            <a class="collapse-item" href="cards.html">Cards</a>
          </div>
        </div> 
      </li> -->
     
    
      <!-- Nav Item - Utilities Collapse Menu -->

      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/order-list']">
          <i class="fas fa-fw fa-th-list"></i>
          <span>Orders</span></a>
      </li>

      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/product-list']">
          <i class="fas fa-fw fa-th-list"></i>
          <span>Products</span></a>
      </li>

      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/category-list']">
          <i class="fas fa-fw fa-th-list"></i>
          <span>Categories</span></a>
      </li>
      <!-- Divider -->
      <hr class="sidebar-divider">
    
    
      <!-- Nav Item - Pages Collapse Menu -->
     <!--  <li class="nav-item">
        <a class="nav-link collapsed" href="Subcription.html" data-toggle="collapse" data-target="#collapsePages" aria-expanded="true" aria-controls="collapsePages">
          <i class="fas fa-fw fa-hand-point-right"></i>
          <span>Subcription</span>
        </a>
        <div id="collapsePages" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
            <h6 class="collapse-header">Login Screens:</h6>
            <a class="collapse-item" href="login.html">Login</a>
            <a class="collapse-item" href="register.html">Register</a>
            <a class="collapse-item" href="forgot-password.html">Forgot Password</a>
            <div class="collapse-divider"></div>
            <h6 class="collapse-header">Other Pages:</h6>
            <a class="collapse-item" href="404.html">404 Page</a>
            <a class="collapse-item" href="blank.html">Blank Page</a>
          </div>
        </div>
      </li> -->
     <li class="nav-item" style="visibility: hidden;">
        <a class="nav-link" [routerLink]="['/subscription-list']">
          <i class="fas fa-fw fa-hand-point-right"></i>
          <span>Subcription</span></a>
      </li>
    
      <!-- Nav Item - Charts -->
      <li class="nav-item" style="visibility: hidden;">
        <a class="nav-link" [routerLink]="['/customer-list']">
          <i class="fas fa-fw fa-user"></i>
          <span>Customers</span></a>
      </li>
    
      <!-- Nav Item - Tables -->
      <li class="nav-item" style="visibility: hidden;">
        <a class="nav-link" [routerLink]="['/settings']">
          <i class="fas fa-fw fa-cog"></i>
          <span>Settings</span></a>
      </li>
    
      <!-- Divider -->
      <hr class="sidebar-divider d-none d-md-block" style="visibility: hidden;">
    
      <!-- Sidebar Toggler (Sidebar) -->
      <div class="text-center d-none d-md-inline">
        <button class="rounded-circle border-0" id="sidebarToggle" (click)="toggleSidebar()"></button>
      </div>
    
    </ul>
    